export const makeTitle = props => {
    const { theme, as } = props;
    return `font-size: ${theme.fonts.sizes[as]};
          font-weight: 600;
          margin: 0;`;
};
